import { observable } from "mobx";
import { Type } from "class-transformer";
import OpeningHoursKind from "./openingHoursKind";
import OpeningHoursWeekResponse from "./openingHoursWeekResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class OpeningHoursResponse {
  @observable
  kind!: OpeningHoursKind;

  /**
   * Opening hours valid since.
   */
  @observable
  @Type(() => Date)
  validSince: Date;

  /**
   * Opening hours valid until.
   */
  @observable
  @Type(() => Date)
  validUntil: Date;

  @observable
  @Type(() => OpeningHoursWeekResponse)
  week: OpeningHoursWeekResponse;
}
